import Signup from "../../../../jsx/pages/Customer/Signup";

const SignupWrapper = function (props) {
  return <Signup />;
};

export default constore(SignupWrapper);
